<template>
  <div class="product_list">
    <ul>
      <template>
        <li class="one_product">
          <div class="leftCon">
            <div class="info">
              <p class="tit">{{ product.name }}</p>
              <ul>
                <li class="range">
                  <div class="key">
                    {{ product.rateRangeLeft }}<b class="symbol">%～</b
                    >{{ product.rateRangeRight }}<b class="symbol">%</b>
                  </div>
                  <div class="value">参考利率范围</div>
                </li>
                <li class="comm">
                  <div class="key">{{ product.monthRange }}</div>
                  <div class="value">融资期限</div>
                </li>
                <li class="comm">
                  <div class="key">{{ product.moneyRange }}</div>
                  <div class="value">融资额度</div>
                </li>
              </ul>
            </div>
          </div>
          <div class="btn" @click="applyNow">
            立即申请
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
// 引入产品基础数据
export default {
  props: ["product"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    applyNow() {
      this.$emit("applyNow", true);
    }
  }
};
</script>
<style lang="scss" scoped>
ul,
ol {
  list-style: none;
}
/* 产品列表 */
.product_list {
  background-color: #fff;
  height: auto;
  width: 80%;
  margin-left: 10%;
  .one_product {
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 30px 40px 60px 50px;
    border-bottom: 2px solid #f5f6fa;
    & > :last-child {
      border: none;
    }
    .leftCon {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex: 1;
    }
    .btn {
      cursor: pointer;
      width: 106px;
      height: 40px;
      background-color: #3da0fd;
      font-size: 14px;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      color: #ffffff;
      font-family: SourceHanSansCN-Regular;
    }
    .info {
      flex: 1;
      padding: 0 10% 0 4%;
      .tit {
        font-family: SourceHanSansCN-Normal;
        font-size: 24px;
        color: #333;
        font-weight: bold;
      }
      .introduce {
        font-family: SourceHanSansCN-Normal;
        font-size: 14px;
        font-stretch: normal;
        line-height: 20px;
        letter-spacing: 0px;
        color: #666666;
        margin-top: 20px;
      }
      ul {
        margin-top: 46px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .range {
          width: 170px;
          .key {
            font-family: ArialMT;
            font-weight: bold;
            font-stretch: normal;
            letter-spacing: -2px;
            color: #3da0fd;
            font-size: 30px;
          }
          .symbol {
            font-size: 14px;
            color: #3da0fd;
          }
          .value {
            font-family: SourceHanSansCN-Normal;
            font-size: 14px;
            color: #666666;
            margin-top: 25px;
          }
        }
        .comm {
          .key {
            font-family: SourceHanSansCN-Normal;
            color: #666;
            font-size: 20px;
            line-height: 40px;
          }
          .value {
            font-family: SourceHanSansCN-Normal;
            font-size: 14px;
            color: #666666;
            margin-top: 25px;
          }
        }
      }
    }
    .tishiDIv {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .mes {
        font-size: 16px;
        line-height: 32px;
        p {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          b {
            width: 20px;
            height: 20px;
            margin-right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/qianfan/component/detaillist.vue